import axios from 'axios';
const state = {
    staff: null,
    outh: null,
}

const actions = {
    fetchStaff(state, id_token) {
        axios
        .get(process.env.VUE_APP_API + "/api/agcy/agency_staffs/ping", {headers: {'Authorization': 'Bearer ' + id_token}})
        .then(response => {
          state.commit('setStaff', response.data)
          return response.data
        }).catch(() => {
        })
    }
}

const mutations = {
    setStaff(state, staff) {
      state.staff = staff
    },
    setStaffOuth(state, outh){
      state.outh = outh
    },
}

const getters = {
  getStaff(state) {
    return state.staff;
  }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
